import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core/react/i18n';

import { IbanForm } from 'src/app/shared/components/payments';

import { NameInputWrapper } from '../NameInputWrapper';
import { SubmitButton } from '../SubmitButton';

import { useStripeSepa } from './useStripeSepa';

export const StripeSepa: React.FC<Parameters<typeof useStripeSepa>[0]> = (props) => {
	const {
		data: { displayed, expanded, ref, loading, disabled, ...restData },
		actions: { handleExpandClick, ...restActions },
	} = useStripeSepa(props);

	if (!displayed) return null;

	return (
		<>
			<Button
				className={cn({ hidden: expanded })}
				variant="primary"
				size="small"
				onClick={handleExpandClick}
				data-qa="sepa-form-expand-button"
			>
				<Translate value="corgi.co.promote.pay_with_bank_account" />
			</Button>
			<div className={cn('flex gap-3', { hidden: !expanded })} data-testid="form-wrapper">
				<div className="rounded-large elevation-elevated flex w-full flex-col gap-2 p-5" data-qa="sepa-form">
					<div className="pb-2">
						<Text fontWeight="bold" ref={ref} tabIndex={-1}>
							<Translate value="corgi.co.promote.pay_with_bank_account" />
						</Text>
					</div>
					<div className="flex flex-col gap-2">
						<NameInputWrapper disabled={loading} paymentType="sepa" />
						<IbanForm
							{...restData}
							{...restActions}
							submitButton={<SubmitButton disabled={disabled} loading={loading} />}
						/>
					</div>
				</div>
			</div>
		</>
	);
};
